function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import { ActionListContext } from '../ActionList';
function ActionListTrigger(props) {
  const {
    triggerButtonMetaData,
    refs
  } = props;
  const {
    setIsOpen,
    isOpen
  } = useContext(ActionListContext);
  const handleClick = event => {
    event.preventDefault();
    setIsOpen(open => {
      return !open;
    });
    if (triggerButtonMetaData.onClick) {
      triggerButtonMetaData.onClick(event);
    }
  };
  return /*#__PURE__*/React.createElement(Button, _extends({}, triggerButtonMetaData, {
    ref: refs.setReference,
    onClick: handleClick,
    dropdownOpen: isOpen,
    isFloatingComp: true
  }));
}
ActionListTrigger.propTypes = {
  triggerButtonMetaData: PropTypes.object,
  refs: PropTypes.object
};
export default ActionListTrigger;